module.exports = __webpack_public_path__ + "img/img_police.e6c5e9a3.jpg";